var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-container', {
    staticStyle: {
      "height": "400px"
    }
  }, [_c('v-row', {
    staticClass: "fill-height",
    attrs: {
      "align-content": "center",
      "justify": "center"
    }
  }, [_c('v-col', {
    staticClass: "text-subtitle-1 text-center",
    attrs: {
      "cols": "12"
    }
  }, [_vm._v(" " + _vm._s(_vm.showLoadingPrefixText ? 'Loading' : '') + " " + _vm._s(_vm.title) + " ")]), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-progress-linear', {
    attrs: {
      "color": "primary accent-4",
      "indeterminate": "",
      "rounded": "",
      "height": "6"
    }
  })], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }